import { UXCustomizationType } from "@gtmhub/uxcustomization/models";

export interface INavItem {
  id: string;
  uxcType: UXCustomizationType;
  color?: string;
  title?: string;
  icon?: string;
  order?: number;
  lastVisited?: string;
  favoriteId?: string;
}

export type NavItemsType = "okrs" | "sessions" | "whiteboards" | "kpis" | "tasks" | "insightboards" | "lists" | "people"; // will depend on api parameters

export const uxcToNavItemsMap: { [K in UXCustomizationType]?: NavItemsType } = {
  session: "sessions",
  whiteboard: "whiteboards",
  kpigroup: "kpis",
  task: "tasks",
  dashboard: "insightboards",
  list: "lists",
  team: "people",
  user: "people",
};

export type NavItemsGroupType = "suggested" | "favorites" | "recent";
export interface NavItemsSectionConfig {
  visibleItemsCount: number;
  sectionLabelKey: string;
  itemsType: NavItemsType;
  itemsGroupType: NavItemsGroupType;
  enableContextMenu?: boolean;
  enableDragAndDrop?: boolean;
}

export interface NavItemsContextMenuConfig {
  itemsType: NavItemsType;
  itemsGroupType: NavItemsGroupType;
}
